import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { roundsWinBetTypes } from '../../store/roundsWinBetTypes';
import { ROUND_BET_TYPE_VIEW } from '../../enums/betTypesEnum';
import {
  BANKER_CARDS_BOX,
  CARDS_BOX,
  CARDS_TYPE_BETSHOP,
  HORIZONTAL_CARDS_INDEX,
} from '../../enums/cardTypes';
import { IDS } from '../../enums/constants';
import { BANKER_CARD, PLAYER_CARD } from '../../enums/cardOwner';

export const BetShopLastResults = observer(() => {
  const { winBetTypes } = roundsWinBetTypes;
  const t = useTranslation();

  const LastThreeResults = useCallback(() => {
    if (winBetTypes.length) {
      const lastThree = [...winBetTypes].splice(-3).reverse();
      return (
        <>
          {lastThree.map(({ roundId, roundData }) => {
            const playerCards = roundData.cards.filter(({ owner }) => owner === PLAYER_CARD);
            const bankerCards = roundData.cards.filter(({ owner }) => owner === BANKER_CARD);
            return (
              <div key={roundId} className='bb-last-results-info-row'>
                <div className='bb-last-results-info-col'>
                  <div
                    className={`bb-last-results-cards bb-left-deck ${
                      roundData.winType === ROUND_BET_TYPE_VIEW.PLAYER ? 'win' : ''
                    } `}
                  >
                    {CARDS_BOX.map((item, index) => {
                      const card = playerCards.length > index ? playerCards[index] : null;
                      return (
                        <div
                          key={IDS[index]}
                          className={`bb-last-results-card ${
                            Number.isInteger(card?.card) ? '' : 'invisible'
                          }`}
                        >
                          <div className={`bb-card ${Number.isInteger(card?.card) ? 'open' : ''}`}>
                            <div className={`bb-card-front ${CARDS_TYPE_BETSHOP[card?.card]}`} />
                            <div className='bb-card-back' />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className='bb-last-results-info-col'>
                  <p className='bb-last-results-nums'>
                    <span
                      className={`bb-last-results-num ${
                        roundData.winType === ROUND_BET_TYPE_VIEW.PLAYER ? 'win' : ''
                      }`}
                    >
                      {roundData.playerTotalPoint}
                    </span>
                    :
                    <span
                      className={`bb-last-results-num ${
                        roundData.winType === ROUND_BET_TYPE_VIEW.BANKER ? 'win' : ''
                      }`}
                    >
                      {roundData.bankerTotalPoint}
                    </span>
                  </p>
                </div>
                <div className='bb-last-results-info-col'>
                  <div
                    className={`bb-last-results-cards bb-right-deck ${
                      roundData.winType === ROUND_BET_TYPE_VIEW.BANKER ? 'win' : ''
                    }`}
                  >
                    {BANKER_CARDS_BOX.map((item, index) => {
                      const card = bankerCards.length > 1 - index ? bankerCards[1 - index] : null;
                      return (
                        <div className='bb-last-results-card' key={IDS[index]}>
                          <div className={`bb-card ${Number.isInteger(card?.card) ? 'open' : ''}`}>
                            <div className={`bb-card-front ${CARDS_TYPE_BETSHOP[card?.card]}`} />
                            <div className='bb-card-back' />
                          </div>
                        </div>
                      );
                    })}
                    <div
                      className={`bb-last-results-card ${
                        CARDS_TYPE_BETSHOP[bankerCards[HORIZONTAL_CARDS_INDEX]?.card]
                          ? ''
                          : 'invisible'
                      }`}
                    >
                      <div
                        className={`bb-card ${
                          CARDS_TYPE_BETSHOP[bankerCards[HORIZONTAL_CARDS_INDEX]?.card]
                            ? 'open'
                            : ''
                        }`}
                      >
                        {bankerCards.length > HORIZONTAL_CARDS_INDEX &&
                          bankerCards[HORIZONTAL_CARDS_INDEX] && (
                            <div
                              className={`bb-card-front ${
                                CARDS_TYPE_BETSHOP[bankerCards[HORIZONTAL_CARDS_INDEX].card]
                              }`}
                            />
                          )}
                        <div className='bb-card-back' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      );
    }
    return null;
  }, [winBetTypes]);

  return (
    <div className='bb-last-results'>
      <p className='bb-last-results-heading'>{t('LAST_RESULTS')}</p>
      <div className='bb-last-results-content'>
        <div className='bb-last-results-titles'>
          <p className='bb-last-results-title'>{t('PLAYER')}</p>
          <p className='bb-last-results-title'>{t('TIE')}</p>
          <p className='bb-last-results-title'>{t('BANKER')}</p>
        </div>
        <div className='bb-last-results-info'>
          <LastThreeResults />
        </div>
      </div>
    </div>
  );
});
